
import { Link } from 'react-router-dom';

export default function ProblemsSection() {
  const problems = [
    {
      icon: 'ri-emotion-unhappy-line',
      title: '定期テストの点数が伸びない',
      description: '勉強しているのに成績が上がらず、どうすればいいかわからない'
    },
    {
      icon: 'ri-question-line',
      title: '勉強のやり方がわからない',
      description: '何から手をつければいいのか、効率的な学習方法が見つからない'
    },
    {
      icon: 'ri-book-open-line',
      title: '提出物が間に合わない',
      description: '学校の課題や提出物の管理ができず、内申点が心配'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '高校受験が不安',
      description: '志望校に合格できるか不安で、何をすべきか迷っている'
    },
    {
      icon: 'ri-home-4-line',
      title: '家では集中できない',
      description: '自宅だと誘惑が多く、勉強に集中できる環境がない'
    },
    {
      icon: 'ri-user-search-line',
      title: '自分に合った塾が見つからない',
      description: '大手塾では埋もれてしまい、個別のサポートが受けられない'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* ターゲット別ボタン */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <a
            href="https://lp2.29-jyuku.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#4a90e2] text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-[#3a7bc8] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-book-2-line text-xl w-5 h-5 flex items-center justify-center"></i>
            中１・２の方はこちら
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href="https://lp1.29-jyuku.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#e8734a] text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-[#d4633c] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-trophy-line text-xl w-5 h-5 flex items-center justify-center"></i>
            中３受験生の方はこちら
            <i className="ri-arrow-right-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            <strong>廿日市で塾</strong>をお探しの方<br />こんなお悩み、ありませんか？
          </h2>
          <div className="w-24 h-1 bg-[#4a90e2] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-[#f8f9fa] rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${problem.icon} text-3xl text-[#4a90e2]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a2332] mb-3">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-2xl font-semibold text-[#1a2332] mb-4">
            そのお悩み、学習塾NICKが解決します！
          </p>
          <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
            <strong>学習塾</strong>NICKは、廿日市市大野の地域密着型<strong>学習塾</strong>です。<strong>中学生</strong>一人ひとりの学習状況に合わせ、集団指導だけでなく、完全<strong>個別指導</strong>や<strong>少人数指導</strong>で、確実な<strong>成績アップ</strong>をサポートします。
          </p>
        </div>
      </div>
    </section>
  );
}
